var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollTop),expression:"scrollTop"}],class:_vm.nopadding ? 'fixed-nav-no-padding' : 'fixed-nav',style:({ top: _vm.downloadVisible ? '14rem' : '6rem' })},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }